import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
// actions
import { getProductCarouselData } from '../../../actionCreators/productCarousel';
// helpers
import { removeDomainName } from '../../../utils/helper';
// components
import LazyLoadProvider from '../LazyLoadProvider/LazyLoadProvider';
import Slider from '../Slider/Slider';
// styles
import './ProductCarouselItems.scss';

let currencyCode = '';
let currencySymbol = '';
class ProductCarouselItems extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hideComponent: false,
    };
    this.hideComponent = this.hideComponent.bind(this);
    this.goToProduct = this.goToProduct.bind(this);
    this.goToCategory = this.goToCategory.bind(this);
  }

  componentDidMount() {
    const { count, categoryId, getProductCarouselData, productCarouselData } = this.props;
    if (
      !(
        productCarouselData &&
        productCarouselData[categoryId] &&
        productCarouselData[categoryId].length
      )
    ) {
      getProductCarouselData(categoryId, count);
    }
  }

  componentDidUpdate(prevProps) {
    const { productCarouselData, categoryId } = this.props;
    if (
      prevProps.productCarouselData[categoryId] !== productCarouselData[categoryId] &&
      !productCarouselData[categoryId].length
    ) {
      this.hideComponent();
    }
  }

  hideComponent() {
    this.setState({ hideComponent: true });
  }

  goToProduct(product) {
    const { history, localeInfo } = this.props;
    history.push({
      pathname: removeDomainName(product.product_url, '', localeInfo?.countryCode),
      state: { productId: product.id, section: 'prod' },
    });
  }

  goToCategory() {
    const { categoryId, categoryUrl, history, localeInfo } = this.props;
    history.push({
      pathname: removeDomainName(categoryUrl, '', localeInfo?.countryCode),
      state: { categoryId, section: 'cat' },
    });
  }

  render() {
    const {
      count,
      categoryTitle,
      categoryId,
      currencyMark,
      productCarouselData,
      aspectRatio,
      slidesPerView,
      paddingBtwnSlides,
      dataLocale: { VIEW_ALL, CURRENCY_CODE },
    } = this.props;
    const productList =
      (productCarouselData && productCarouselData[categoryId]) || new Array(count).fill('');
    return (
      <React.Fragment>
        {!this.state.hideComponent && productList.length > 0 && (
          <div className="product-carousel">
            <div className="display-flex justify-space-between pd-l8 pd-r8">
              <div className="text-left fsp14 roboto mr-b8">{categoryTitle}</div>
              <div className="text-left fsp14 roboto mr-b8 text-topaz" onClick={this.goToCategory}>
                {VIEW_ALL}
              </div>
            </div>
            <Slider
              aspectRatio={aspectRatio}
              paddingBtwnSlides={paddingBtwnSlides}
              slidesPerView={slidesPerView}
            >
              {productList.map((product, index) => {
                currencyCode =
                  product && product.prices && product.prices.length > 0
                    ? product.prices[0].currencyCode ||
                      product.prices[0].currency_code ||
                      CURRENCY_CODE
                    : CURRENCY_CODE;
                currencySymbol = <span>{currencyMark[currencyCode]}</span>;
                return (
                  <div
                    key={`slider-child-${index}`}
                    className="w100 h100 block"
                    style={{ paddingRight: paddingBtwnSlides }}
                  >
                    <div
                      className="product-tile block bg-color_white bora-4 overflow-hidden"
                      onClick={() => (product ? this.goToProduct(product) : '')}
                    >
                      <LazyLoadProvider
                        alt={`img-${index}`}
                        className="lazy pd-t4"
                        src={product ? product.image_url : ''}
                        style={{}}
                      ></LazyLoadProvider>
                      <div className="brand-name text-left pd-t4 pd-b4 pd-l4">
                        {product ? product.brand_name : ''}
                      </div>
                      <div className="price text-left pd-b4 pd-l4 text-topaz">
                        {product ? (
                          <React.Fragment>
                            {currencySymbol}
                            {
                              product.prices.filter(price => {
                                return price.name === 'Lenskart Price';
                              })[0].price
                            }
                          </React.Fragment>
                        ) : (
                          ' '
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  productCarouselData: state.productCarousel.productCarouselData,
  dataLocale: state.locale,
  localeInfo: state.common.localeInfo,
});

const mapDispatchToProps = dispatch => {
  return {
    getProductCarouselData: (catId, count) => dispatch(getProductCarouselData(catId, count)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductCarouselItems);
